{
  "cta": {"action": "Sign in"},
  "features": {
    "items": [
      {
        "desc": "Browse the corpus document by document, or open any document at an exact version.",
        "title": "Find your documents"
      },
      {
        "desc": "Mark entities consistently with shared guidelines. Every annotation records how it was made.",
        "title": "Annotate precisely"
      },
      {
        "desc": "Create a formal ontology of the structure and relations in your documents.",
        "title": "Build a data model"
      },
      {
        "desc": "Share Runs with colleagues, review changes before they are merged, and keep every version.",
        "title": "Work together"
      }
    ]
  },
  "header": {"title": "DMW"},
  "hero": {
    "more": "See the steps",
    "start": "Sign in",
    "title": "Annotate documents and build a data model"
  },
  "heroCard": {
    "annotatedDesc": "People, places, dates…",
    "annotatedTitle": "Annotated entities",
    "doc": "A document",
    "modelDesc": "Relations and structure",
    "modelTitle": "Data model"
  },
  "workflow": {
    "steps": [
      {"title": "Import your documents"},
      {"title": "Annotate entities"},
      {"title": "Build the ontology"}
    ]
  }
}
